import { Injectable } from "@angular/core";
import { SmmService } from "./smm.service";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class SmmUserService {
  constructor(private smmService: SmmService, private http: HttpClient) {}

  public searchUsers(from, size, bool, orderBy) {
    const body = {
      size: size,
      from: from,
      orderBy: orderBy,
      filter: bool,
    };
    return this.smmService.getUsers(body);
  }

  public searchUserByIdOrLink(from, size, id) {
    const body = {
      from: from,
      size: size,
      filter: {},
    };

    const idPattern = "^[0-9]+$";
    // console.log(id.toLowerCase().match(idPattern));
    if (id.toLowerCase().match(idPattern) !== null) {
      body.filter["id"] = id;
    } else {
      if (id.indexOf("https://") > -1) {
        // id = this.globalService.extractIdFromLink(id);
        if (id.indexOf("id=") > -1) {
          const temp = id.split("&");
          id = temp[0];
        }
        // else if (id.indexOf('?') > -1) {
        //   const temp = id.split('?');
        //   id = temp[0];
        // }
      }
      body.filter["link"] = id;
    }
    // console.log(body);
    return this.smmService.getUsers(body);
  }

  public getUserById(id) {
    return this.smmService.getUserById(id);
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_services/smm-user.service.ts